<div class="row border-bottom">
  <nav class="navbar navbar-top" role="navigation" style="margin-bottom: 0">
    <div class="navbar-left">
      <button class="btn btn-primary btn-circle" (click)="toggleNavigation()">
        <i class="fa fa-bars"></i>
      </button>
      <!-- current user -->
      <a [routerLink]="['/profile/users']">
        <i class="fa fa-user tig-fa"></i>{{OBJ_current_user.firstname}} {{OBJ_current_user.lastname}}
      </a>
    </div>
    <div class="navbar-right">
      <!-- client selection -->
      <button class="btn btn-default btn-circle" routerLinkActive="active" [routerLink]="['/client-selection']" title="{{'clients'|translate}}">
        <img *ngIf="OBJ_client.logo" alt="Logo" class="img-circle" src="{{OBJ_client?.logo}}" />
        <span *ngIf="!OBJ_client.logo" class="img-circle">{{OBJ_helper_service.getInitials(OBJ_client.name)}}</span>
      </button>
      <!-- logout -->
      <button class="btn btn-default btn-circle" [routerLink]="['/login']" title="{{'oMisc.sLogout'|translate}}">
        <i class="fa fa-sign-out"></i>
      </button>
      <!-- languages -->
      <div dropdown>
        <button class="btn btn-default btn-circle active" dropdownToggle title="{{'languages'|translate}}">{{OBJ_translate_service.currentLang.toUpperCase()}}</button>
        <div class="animated fadeInDown dropdown-menu" *dropdownMenu>
          <ng-container *ngFor="let lang of OBJ_translate_service.getLangs()">
            <button *ngIf="lang !== OBJ_translate_service.currentLang" class="btn btn-default btn-circle" (click)="OBJ_translate_service.use(lang)">
              {{lang.toUpperCase()}}
            </button>
          </ng-container>
        </div>
      </div>

      <!-- help -->
      <button class="btn btn-warning btn-circle" routerLinkActive="active" (click)="openExternalUrl('https://support.vogel.de')" title="{{'help'|translate}}">
        <i class="fa fa-question"></i>
      </button>
    </div>
  </nav>
</div>
